import styled from "@emotion/styled"
import SubNavCardRetailer from "components/cards/SubNavCardRetailer"
import SubNav from "components/sub-nav/Pane"
import { useConsole } from "contexts/Console"
import { useEnv } from "contexts/Env"
import { compile } from "path-to-regexp"

const Figure = styled.figure`
  img {
    max-height: 32px;
    max-width: 120px;
  }
`

export default function Pane({ children, establishmentRetail, isDealer, locate, toggle_label, ...props }) {
  const console = useConsole()
  const env = useEnv()

  const logoData = establishmentRetail?.dealer.logos?.white != null || ""
  console.log(logoData, establishmentRetail?.dealer?.logos, "ooooooo")

  toggle_label =
    establishmentRetail?.dealer?.logos && logoData ? (
      <Figure>
        <img
          alt={toggle_label.replace("$name", establishmentRetail.dealer.name)}
          src={new URL(`/retailers/${establishmentRetail.dealer.logos?.white}`, env.statics)}
        />
      </Figure>
    ) : (
      establishmentRetail.dealer.name
    )
  console.log("🚀 ~ file: Pane.js:32 ~ Pane ~ establishmentRetail.dealer:", establishmentRetail.dealer)

  const Card = props => <SubNavCardRetailer {...props} locate={locate} establishmentRetail={establishmentRetail} isDealer={isDealer} />

  // define slug
  // and remove card that can't have a link
  // and remove group card if establishement's not part of group
  props.cards = props.cards
    .map(card => {
      const dealer = establishmentRetail.dealer.type === "SERVICECENTER" ? undefined : establishmentRetail.dealer.urlRolexV7
      const establishment =
        establishmentRetail.dealer.type === "SERVICECENTER"
          ? establishmentRetail.establishment?.urlRolexV7
          : establishmentRetail?.establishment?.urlRolexV7?.split("/")?.[1]

      try {
        // no group page
        if (establishmentRetail.dealer.type !== "SERVICECENTER" && establishmentRetail.dealer.nbrEstablishment === 1 && !card.link.includes(":establishment"))
          return null
        card.slug = compile(card.link)({ dealer, establishment })
        return card
      } catch {
        return null
      }
    })
    .filter(Boolean)

  console.verbose("retailer:sub-nav:Pane(%o)", { cards: props.cards, establishmentRetail })
  return <SubNav {...props} toggle_label={toggle_label} ariaLabel={establishmentRetail.dealer.name} Card={Card} />
}
